
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"625.763","height":"722.833"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('linearGradient',{attrs:{"id":"b","x1":".5","x2":".5","y2":"1","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#fff"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#fff","stop-opacity":"0"}})]),_c('filter',{attrs:{"id":"a","x":"0","y":"0","width":"625.763","height":"722.833","filterUnits":"userSpaceOnUse"}},[_c('feOffset'),_c('feGaussianBlur',{attrs:{"stdDeviation":"10","result":"blur"}}),_c('feFlood',{attrs:{"flood-color":"#fff"}}),_c('feComposite',{attrs:{"operator":"in","in2":"blur"}}),_c('feComposite',{attrs:{"in":"SourceGraphic"}})])]),_c('g',{attrs:{"filter":"url(#a)"}},[_c('path',{attrs:{"data-name":"Path 49708","d":"M336.156-1.087c-.039-.28-28.94 8.737-54.3 8.508S233.92-1.41 233.867-1.087L0 621.867c186.02 53.529 377.311 52.79 565.763 0z","transform":"translate(30 31.1)","fill":"url(#b)"}})])])
          )
        }
      }
    